module.exports = __webpack_public_path__ + "img/2.972d4723.png";